export const wallpapers = [
  { id: "desert", name: "Desert", image: require("../assets/light.webp") },
  { id: "night", name: "Desert at Night", image: require("../assets/dark.webp") },
];
export function wallpaperImage(id, theme) {
  const selected = wallpapers.find(item => item.id === id);
  return selected ? selected.image : wallpapers[theme === "dark" ? 1 : 0].image;
}
